import React, { useState, useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";
import { MdLocationOn, MdOutlineWatchLater } from "react-icons/md";
import { useSelector, useDispatch, connect } from "react-redux";
import { BsPaperclip } from "react-icons/bs";
// import RedoActions from "./RedoActions";
// import PatientActions from "../../components/Cart/PatientDetailsAction";
import "./dldetailForm.css";
import DLActions from "./DLActions";
import Modal from "react-responsive-modal";

function DldetailForm(props) {
  const { setOpenSuccessModal, setOpen, push, position } = props;

  const [userNumber, setUserNumber] = useState("");
  const [number, setNumber] = useState("");
  const [userName, setUserName] = useState("");
  const [userCity, setUserCity] = useState("");
  const [nameError, setNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [ageError, setAgeError] = useState("");
  const [userEmailError, setUserEmailError] = useState("");
  const [userCityError, setUserCityError] = useState("");
  const [displayCityList, setDisplay] = useState(true);
  const [loginForm, setLoginForm] = useState(true);
  const [success, setSucess] = useState(false);
  const [cityFocus, setCityFocus] = useState("");

  const [previewName, setPreview] = useState("");
  const [previewError, setFileError] = useState("");
  const [filename, setFilename] = useState("");
  const [fileSelected, setFileSelected] = useState();

  const [checkboxState, setCheckboxState] = useState(true);
  const [openSuccModel, setSucc] = useState(false);

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const handelfile = (e) => {
    console.log("user input", e.target.value);
    setFileSelected(e.target?.files[0]);
    var myTruncatedString =
      e.target?.files[0]?.name?.substring(0, 10) + e.target?.files[0]?.type;

    setPreview(myTruncatedString);

    const filePath = e.target.value;
    var allowedExtensions = /(\.png|\.pdf|\.jpg|\.jpeg)$/i;

    if (e.target?.files[0]?.size > 5000000) {
      setFileError("File size should be less then 5 MB");
    } else if (allowedExtensions.exec(filePath)) {
      setPreview(e.target.files[0].name);

      var myTruncatedString =
        e.target?.files[0]?.name.substring(0, 10) +
        "." +
        e.target?.files[0]?.type;

      setPreview(myTruncatedString);

      setFileError("");
      var file = e.target?.files[0];
      getBase64(file).then((data) => {
        setFilename(data);
        // console.log(data);
      });
    } else {
      setFilename("");
      setPreview("");
      // console.log("inside else", e.target?.files[0]);
      if (e.target?.files[0]) {
        setFileError("invalid file type");
      }
    }
    e.target.value = "";
  };

  //HANDEL USERNAME FUNCTON BELOW THIS COMMENT
  const handelUserName = (e) => {
    setUserName(e.target.value);
    setNameError("");
    let characterRegex = /^[A-Za-z ]+$/;
    if (e.target.value == "") {
      setNameError("");
    } else if (!e.target.value.match(characterRegex)) {
      setNameError("Enter a valid name");
    } else {
      setNameError("");
    }
  };

  const handelPhoneNumber = (e) => {
    setUserNumber(e.target.value);
    setPhoneError("");
    console.log(e.target.value);
    let phoneno = /^\d{10}$/;
    if (e.target.value == "") {
      setPhoneError("");
    } else if (!e.target.value.match(phoneno) || parseInt(userNumber[0]) < 6) {
      setPhoneError("Enter a valid number");
    } else {
      setPhoneError("");
    }
  };

  const openSucess = () => setSucc(true);
  const closeSuccess = () => setSucc(false);

  var url = `https://redcliffelabs.com${location.pathname}/${position ? position : ""
    }/${location.search}`;

  // handel submit
  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();

    if (checkVal) {
      let formData = new FormData();
      formData.append("name", userName);
      formData.append("mobile", userNumber);
      formData.append("source", "Ecommerce");
      formData.append("address", userCity);
      formData.append("city", userCity);
      formData.append("url", url);
      if (fileSelected) {
        formData.append("image", fileSelected);
      } else {
        formData.append("testname", previewName);
      }

      setUserNumber("");
      setUserName("");
      setUserCity("");
      setPreview("");
      setSucess(true);
      openSucess(true);
      setTimeout(() => {
        setSucess(false);
      }, 2000);
      if (push) {
        history.push({
          search: "?/ThankYou",
        });
      }
      props.postDldetailFormData(formData);
    }
  };

  //handel city change
  const handelCityChange = (e) => {
    setUserCity(e.target.value);
    setDisplay(true);
    let characterRegex = /^[A-Za-z ]+$/;
    if (e.target.value == "") {
      setUserCityError("");
    } else if (!e.target.value.match(characterRegex)) {
      setUserCityError("Enter a valid city");
    } else {
      setUserCityError("");
    }
  };

  //   //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;

  //set input city
  const setInputcity = (val) => {
    setUserCity(val);
    setDisplay(false);
  };

  //   //handelchange
  //   const handleCheckChange = (e) => {
  //     setCheckboxState(!checkboxState);
  //   };

  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userNumber.match(phoneno) || parseInt(userNumber[0]) < 6) {
      setPhoneError("Enter a valid number");
      return false;
    } else {
      return true;
    }
  };

  const handleCheckChange = (e) => {
    setCheckboxState(!checkboxState);
  };

  //model div
  const SuccessModel = ({ number }) => {
    return (
      <div className="SuccessMsg_upload">
        <h2>
          We have received your information. We shall call you in few minutes to
          confirm the details. For any queries please call us at &nbsp;
          <a href={`tel:+91-${number}`} style={{ color: "blue" }}>
            {number}  
          </a>
          - Team Redcliffe Labs
        </h2>
      </div>
    );
  };

  // useEffect(() => {
  //   const userFromLocal = JSON.parse(localStorage.getItem("user"));
  //   var token = userFromLocal?.token;
  //   if (token) {
  //     props?.getProfileDetails(token);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (props?.userProfile?.username && props?.userProfile?.fullname) {
  //     setUserNumber(props?.userProfile?.phonenumber);
  //     setUserName(props?.userProfile?.fullname);
  //     setUserEmail(props?.userProfile?.email);
  //     setUserAge(props?.userProfile?.age);
  //   }
  // }, [props?.userProfile]);

  return (
    <div className="redoForm dldetailForm">
      <form
        className={loginForm ? "modal-form login-form " : "hide"}
        onSubmit={handelSubmit}
      >
        <div className="form__div redoForm__div">
          <h2 className="redoForm_heading ForMargin">Book test</h2>
          <p className="redoForm_para1 ForMargin">
            with largest radiology network in India
          </p>
          <div>
            <div className="form__input redoForm__input ForMargin">
              <span className="userIcon">
                <FaUserCircle />
              </span>
              <div className="inputDiv">
                <input
                  required
                  type="text"
                  placeholder="Enter Name"
                  onChange={handelUserName}
                  value={userName}
                />
              </div>
            </div>
            <span className="FormError">{nameError}</span>
          </div>

          {/* Phone Number Field */}

          <div>
            <div className="form__input numBox redoForm__input ForMargin">
              <span className="numIcon">+91</span>
              <div className="inputDiv">
                <input
                  type="number"
                  placeholder="Enter Phone Number"
                  required
                  onChange={handelPhoneNumber}
                  value={userNumber}
                />
              </div>
            </div>
            <span className="FormError">{phoneError}</span>
          </div>

          {/* City Field */}

          <div className="cityContainer">
            <div
              className="citySelect citySelect1 ForMargin redoForm__input"
              style={{ padding: "0", marginBottom: "0px" }}
            >
              <span className="locIcon  ">
                {" "}
                <MdLocationOn />{" "}
              </span>

              <input
                type="text"
                onBlur={() => setCityFocus(true)}
                placeholder="Enter City"
                onChange={handelCityChange}
                value={userCity}
                required
              />

              {/* <span className="downListIcon">
                  {" "}
                  <AiFillCaretDown />{" "}
                </span> */}

              {/* <AiFillCaretDown /> */}
              {/**CITY LIST ARRAY BELOW */}
            </div>
            <span className="FormError">{userCityError}</span>
            {userCity !== "" ? (
              <div
                className=""
                id="cityList"
                // style={{ border: "1px solid gainsboro" }}
              >
                {userCity !== "" && citiesFromArray && citiesFromArray.cities
                  ? citiesFromArray.cities
                      .filter((name) => {
                        if (userCity == "") {
                          return name;
                        } else if (
                          name.toLowerCase().includes(userCity.toLowerCase())
                        ) {
                          return name;
                        }
                      })
                      .map((values, index) => {
                        if (index < 2) {
                          return (
                            <>
                              <div
                                onClick={() => setInputcity(values)}
                                key={index}
                                className={
                                  displayCityList ? "cityLIstLP" : "displayNone"
                                }
                              >
                                <span>{values}</span>
                              </div>

                              {/* <div
                  className="cityItem"
                  key={index}
                  onClick={() => setCity(filteredName)}
                >
                  {" "}
                  <span>{filteredName}</span>{" "}
                </div>   */}
                            </>
                          );
                        }
                      })
                  : null}
              </div>
            ) : null}
          </div>

          {/* Upload Field */}

          <div className="uploadContainer">
            <div className="uploadDiv1">
              <input
                className="uploadInput"
                placeholder="Mention test or upload.."
                value={previewName}
              />
              <label
                style={{
                  display: "flex",
                  fontSize: "1.9rem",
                  color: "white",
                  background: "#31CCB0",
                  height: "50px",
                  borderRadius: "5px",
                }}
                className="uploadLabel_dldetail"
              >
                <input
                  hidden
                  type="file"
                  id="upload"
                  style={{ border: "1px solid #000" }}
                  placeholder="Enter test name or upload prescription"
                  onChange={handelfile}
                />
                <div
                  style={{
                    width: "5rem",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  className="lastuserIcon uploadIcon uploadIconDiv"
                >
                  <BsPaperclip />
                </div>
              </label>
            </div>
            <span className="FormError">
              {previewError == "" ? null : previewError}
            </span>
          </div>

          <div className="opt_Div">
            <input
              type="checkbox"
              onChange={() => handleCheckChange()}
              defaultChecked
              style={{ width: "18px", height: "18px", marginLeft: "0px" }}
            />
            <span className="textt texttDldetail">
              Opt in for WhatsApp Updates
            </span>
          </div>

          {success ? (
            <span className="success">
              Your form has been submitted successfully!
            </span>
          ) : null}
          <button
            type="submit"
            disabled={
              nameError ||
              userEmailError ||
              phoneError ||
              userCityError ||
              ageError
                ? "disabled"
                : ""
            }
            className={
              nameError ||
              userEmailError ||
              phoneError ||
              userCityError ||
              ageError
                ? "disabled dldetailFormBtn"
                : "dldetailFormBtn"
            }
          >
            SUBMIT
          </button>
        </div>
        <Modal open={openSuccModel} onClose={closeSuccess} center>
          <SuccessModel number={number} />
        </Modal>
      </form>
    </div>
  );
}

const mapStateToProps = (state) => ({
  userProfile: state?.Profile?.profileDate,
  city: state.navCityList.navCities,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // getProfileDetails: (token) => {
    //   dispatch(PatientActions.getProfileDetails(token));
    // },
    postDldetailFormData: (body) => {
      dispatch(DLActions.postDldetailFormData(body));
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(DldetailForm));